import React, { useEffect, useState } from "react"
import { FormattedNumber, injectIntl } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"
import LoggerService from "../../../state/logger/LoggerService"
import { RF_METHOD_TYPES } from "./constants"
import { messages } from "./messages"
import "./styles/rainforest-credit-card.scss"

type OwnProps = {
    amount?: number
    currency?: string
    method: RF_METHOD_TYPES
    payBtnColor: string
    onClick: () => void
    disabled: boolean
    payinConfigId: string
}

const RainforestButton = (props: OwnProps & IntlProps) => {

    const buttonText =
        RF_METHOD_TYPES.PAY_CC ? <div className="pay-text">
            {props.intl.formatMessage(messages.pay)}&nbsp;
            <FormattedNumber
                value={props.amount}
                currency={props.currency}
                style={"currency"}
            />
        </div> : <div className="pay-text">
            {props.intl.formatMessage(messages.storeDetails)} &nbsp;
        </div>

    const [disabled, setDisabled] = useState<boolean>(props.disabled)

    useEffect(() => {
        setDisabled(props.disabled)
    }, [props.disabled])

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        setDisabled(true)
        props.onClick()

        const payload = {
            logMessage: "RF Custom Button Clicked",
            logBody: {
                payinConfigId: props.payinConfigId,
                amount: props.amount,
                method: props.method,
            }
        }
        LoggerService.LogRequest(payload)  
    }
    
    return <div className="conainter-rf-pt-0">
        <button
            className={"btn custom-rf-pay-button"}
            style={
                { backgroundColor: props.payBtnColor, width: "100%", transition: "background-color .15s ease-in-out" }}
            onClick={handleClick}
            disabled={disabled}
        >
            <img className="pay-bag-icon" alt="pay-bag-icon" src="/images/rf_cc/bag.png" />
            {buttonText}
        </button>
    </div>
}
export default injectIntl(RainforestButton)


// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/RainforestButton.tsx